/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import styled from 'styled-components';
import Styles from './ParkingLot.Styles';
import Text from '../../base/Text';
import ValidateButton from '../TicketsWhite/ValidateButton';
import cbxParkingEn from './map/CBX-Mapa-Parking-MAY2023-solo-nombres-ISOMETRICO-completo-ENG.png';
import cbxParkingEs from './map/CBX-Mapa-Parking-MAY2023-solo-nombres-ISOMETRICO-completo-ESP.png';
import cbxParkingEnMobile from './map/mobile/CBX-Mapa-Parking-MAY2023-solo-nombres-ENG.png';
import cbxParkingEsMobile from './map/mobile/CBX-Mapa-Parking-MAY2023-solo-nombres-ESP.png';
import cbxCloseIcon from './map/CBX_closeIcon.png';
import gettingData from '../../../assets/images/clock.gif';
import purple_arrow from "../../../assets/images/purple_arrow.png";
import parkingIcon from '../../../assets/images/icons/parkingIcon.svg';
import TicketInfo from '../TicketInfo/index';
import { getParkingStatus, getQuickData, saveQuickData } from '../../../helpers/CartManager';
import { quickSelector } from '../../base/QuickSelector';


const PurpleUsd = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.purpleUsd}`; // prettier-ignore
const ParkingListItemInfoWrapper = styled.div`${Styles.parkingListItemInfoWrapper}`;
const ParkingListItemProduct = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.parkingListItemProduct}`;
const ParkingListItemInfoLabel = styled(Text).attrs({ bold: true })`${Styles.parkingListItemInfoLabel}`;
const ParkingListItemInfoText = styled(Text)`${Styles.parkingListItemInfoText}`;
const ParkingListItemInfoTextBold = styled(Text)`${Styles.parkingListItemInfoTextBold}`;
const ParkingListItemInfoRow = styled.div`${Styles.parkingListItemInfoRow}`;
const ParkingListItemInfoCol = styled.div`${Styles.parkingListItemInfoCol}`;
const CartSection = styled.div`${Styles.cartSection}`;

/**
 * TicketInfoGrayCollapsable
 * @param {function} buttonAction - Action to execute on button press
 * @param {string} buttonText - Label to display button
 * @param {Object} data - Ticket data from localStorage
 * @param {Object} translations - Current i18n dictionary
 * @returns {JSX.Element}
 */
const Popup = ({
  passRef,
  translations,
  locale,
  width = 768,
  closeFn,
  selectFn,
}) => {
  let recoveredData = {};
  if (typeof window !== 'undefined') {
    recoveredData = JSON.parse(window.localStorage.getItem('parking'));
  }

  return (
    <div
      id="map-popup"
      ref={passRef}
      style={{
        position: 'absolute',
        backgroundColor: 'white',
        width: '300px',
        display: 'none',
        borderRadius: '12px',
        padding: '5px 15px 5px',
        border: '1px solid #726C79 ',
        top: 400,
        left: (width - 300) / 2,
        zIndex: 2
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 5, cursor: 'pointer' }} onClick={closeFn} >
        <img alt="Close" src={cbxCloseIcon} />
      </div>
      <ParkingListItemInfoWrapper>
        {recoveredData && recoveredData.data && recoveredData.data.lot[0] && (
          <ParkingListItemInfoRow style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <ParkingListItemProduct style={{ flex: 4 }}>
              {recoveredData.data.lot[0].location_name}
            </ParkingListItemProduct>
          </ParkingListItemInfoRow>)}
        {recoveredData && recoveredData.data && (
          <ParkingListItemInfoRow>
            <ParkingListItemInfoCol style={{ flex: 2 }}>
              <ParkingListItemInfoRow>
                <ParkingListItemInfoLabel>
                  {`$${recoveredData.data.price / recoveredData.data.days} USD / ${translations.day}`}
                </ParkingListItemInfoLabel>
              </ParkingListItemInfoRow>
              <ParkingListItemInfoText>{translations.infoLot}</ParkingListItemInfoText>
              <ParkingListItemInfoRow>
              <img
                src={parkingIcon}
                alt= ""
                style={{ height: '2em', margin: '0px -3px -6px -7px' }}
              />
                <ParkingListItemInfoText>{translations.parkingSpaceLot}  </ParkingListItemInfoText>
                <ParkingListItemInfoTextBold>{'' + recoveredData.data.spots}</ParkingListItemInfoTextBold>
              </ParkingListItemInfoRow>
              <CartSection style={{ margin: '10px 0px 0px' }}>
                <ValidateButton
                  action={selectFn}
                  disabled={recoveredData.data.spots <= 0}
                  message={translations.selectLabel}
                />
              </CartSection>
            </ParkingListItemInfoCol>
          </ParkingListItemInfoRow>
        )}
        {!recoveredData && (
          <div
            style={{
              padding: '5%',
              width: '100%',
              margin: 'auto',
              justifyContent: 'center'
            }}
          >
            <img
              alt=""
              style={{ margin: 'auto', display: 'block ' }}
              width="150px"
              height="auto"
              src={gettingData}
            />
          </div>
        )}
      </ParkingListItemInfoWrapper>
    </div>
  );
};

/**
* TicketInfo component
* @returns {JSX.Element}
*/
const ParkingLot = ({ 
  translations, 
  locale, 
  getParkingPrice,
  startDate,
  startDateHandler,
  endDate,
  endDateHandler,
  startTime,
  startTimeHandler,
  endTime,
  endTimeHanlder,
  lot,
  ticketType,
  selectorItem,
  minDate,
  maxDate,
  callParkingApi,
  saveParkingInfo,
}) => {

  let parkingLotsData = {};
  let windowWidth = 768;
  let isMobile = windowWidth < 768;
   
  const openHome = () => {
    window.location.href=`/${locale}/`;
  }
  
  if (typeof window !== 'undefined') {
    parkingLotsData = JSON.parse(window.localStorage.getItem('CBX_Parking_Lots'));
    windowWidth = window.innerWidth;
    isMobile = windowWidth < 768;
  }

  const arrEl = [];
  let popup = null;

  const select = (lot, box, evt) => {
    if(startDate && endDate && startTime && endTime) {
      window.localStorage.removeItem('parking');
      const item = parkingLotsData.findIndex(e => e.location_name.includes(lot));
      getParkingPrice(parkingLotsData[item].id);
      const coords = arrEl[box].getBBox();
      popup.style.display = 'inline-block';
      popup.style.left = `${evt.clientX}px`;
      popup.style.top = `${evt.clientY - 300}px`;
    }
  };

  const selectMobile = (lot) => {
    window.localStorage.removeItem('parking');
    const item = parkingLotsData.findIndex(e => e.location_name.includes(lot));
    getParkingPrice(parkingLotsData[item].id);
    popup.style.display = 'inline-block';
  };

  const closePopUp = () => {
    popup.style.display = 'none';
  };

  const selectFn = () => {
    saveQuickData({
      startDate,
      startTime,
      endDate,
      endTime,
      lot
    });
    window.location.href = `/${locale}/lot`;
  };
  const sim = '<';
  return (
    <Fragment>
      <PurpleUsd> <img
                      alt=""
                      width="35px"
                      height="25px"
                      style={{
                        marginInline: "auto",
                        cursor: "pointer",
                        paddingRight: "10px"
                      }}
                      src={purple_arrow}
                      onClick={openHome}
                /> {translations.selectLot}</PurpleUsd>
      {getParkingStatus() === 1 &&
        <p style={{ fontSize: '22px', color: '#726C79', fontWeight: 'bold' }}>{
          locale === 'es' ? "Para verificar disponibilidad ingrese sus horarios de entrada y salida." : "For parking lot availability enter your travel date and arrival schedule."}
        </p>}

      <TicketInfo
        startDate={startDate}
        startDateHandler={startDateHandler}
        endDate={endDate}
        endDateHandler={endDateHandler}
        startTime={startTime}
        startTimeHandler={startTimeHandler}
        endTime={endTime}
        endTimeHanlder={endTimeHanlder}
        lot={lot}
        locale={locale}
        ticketType={ticketType}
        selectorItem="Parking"
        translations={translations}
        minDate={minDate}
        maxDate={maxDate}
        callParkingApi={callParkingApi}
        getParkingPrice={getParkingPrice}
      />
      {!isMobile && (
        <div>
          <p style={{ fontSize: '22px', color: '#726C79', fontWeight: 'bold', margin: '20px'}}> {(locale === 'es') ? "Dale clic a un lote de estacionamiento para reservar tu lugar" : "Click on a parking lot to reserve your spot"} </p>
          <div className="map" style={{ position: 'relative', display: 'flex' }}>
            <img
              alt="Parking Map"
              src={locale === 'es' ? cbxParkingEs : cbxParkingEn}
              width={windowWidth * 0.9}
              style={{
                position: 'absolute', zIndex: -1
              }}
            />
            <svg viewBox={`-250 -30 1600 800`} width={windowWidth * 0.9}>
              <polygon
                ref={r => arrEl[0] = r}
                onClick={evt => select('Lot 1', 0, evt)}
                style={{fill: 'transparent', stroke: 'transparent',  cursor: 'pointer'  }}
                points="850 330 1000 300 1200 400 1050 450"
              />
              <polygon
                ref={r => arrEl[1] = r}
                onClick={evt => select('Lot 2', 1, evt)}
                style={{fill: 'transparent', stroke: 'transparent',  cursor: 'pointer'  }}
                points="600 170 750 140 1000 300 850 330"
              />
              <polygon
                ref={r => arrEl[2] = r}
                onClick={evt => select('Lot 3', 2, evt)}
                style={{ fill: 'transparent', stroke: 'transparent', cursor: 'pointer' }}
                points = "-250 150 -10 100 100 250 -10 300"
              />
              <polygon
                ref={r => arrEl[3] = r}
                onClick={evt => select('Premium', 3, evt)}
                style={{ fill: 'transparent', stroke: 'transparent', cursor: 'pointer' }}
                points="100 170 350 120 600 220 300 300"
              />
              <polygon
                ref={r => arrEl[4] = r}
                onClick={evt => select('Lot A', 4, evt)}
                style={{ fill: 'transparent', stroke: 'transparent', cursor: 'pointer' }}
                points="80 350 230 320 350 400 230 420"
              />
              <polygon
                ref={r => arrEl[5] = r}
                onClick={evt => select('Lot B', 5, evt)}
                style={{ fill: 'transparent', stroke: 'transparent', cursor: 'pointer' }}
                points="360 340 600 270 750 350 480 400"
              />
              <polygon
                ref={r => arrEl[6] = r}
                onClick={evt => select('Lot C', 6, evt)}
                style={{ fill: 'transparent', stroke: 'transparent', cursor: 'pointer' }}
                points="280 450 420 420 700 580 580 620"
              />
              <polygon
                ref={r => arrEl[7] = r}
                onClick={evt => select('Lot D', 7, evt)}
                style={{ fill: 'transparent', stroke: 'transparent', cursor: 'pointer' }}
                points="480 400 750 350 1000 500 800 550"
              />
              <polygon
                ref={r => arrEl[8] = r}
                onClick={evt => select('Lot E', 8, evt)}
                style={{ fill: 'transparent', stroke: 'transparent', cursor: 'pointer' }}
                points="0 500 -40 320 550 620 350 720"
              />
            </svg>
          </div>
        </div>
      )}
      {isMobile && (
        <div><p style={{ fontSize: '16px', color: '#726C79', fontWeight: 'bold'}}> {(locale === 'es') ? "Da clic a un lote de estacionamiento para reservar tu lugar" : "Click on a parking lot to reserve your spot"} </p>
        <div style={{ display: 'flex', justifyContent: 'center', }}>
          
          <div style={{ display: 'flex', position: 'relative', width: '100%' }}>
            <img
              alt="Parking Map"
              src={locale === 'es' ? cbxParkingEsMobile : cbxParkingEnMobile}
              style={{
                objectFit: 'contain',
                width: '100%'
              }}
            />
            <div
              style={{
                width: '20%',
                height: '28%',
                position: 'absolute',
                left: '32%',
                top: '32%',
                cursor: 'pointer',
                transform: 'translate(-50%,-50%)'
              }}
              onClick={() => { selectMobile('Lot 3') }} />
            <div
              style={{
                width: '28%',
                height: '28%',
                position: 'absolute',
                left: '60%',
                top: '37%',
                cursor: 'pointer',
                transform: 'translate(-50%,-50%)'
              }}
              onClick={() => { selectMobile('Premium') }} />
               <div
              style={{
                width: '17%',
                height: '28%',
                position: 'absolute',
                left: '92%',
                top: '50%',
                cursor: 'pointer',
                transform: 'translate(-50%,-50%)'
              }}
              onClick={() => { selectMobile('Lot 2') }} />
              <div
              style={{
                width: '17%',
                height: '15%',
                position: 'absolute',
                left: '91%',
                top: '73%',
                cursor: 'pointer',
                transform: 'translate(-50%,-50%)'
              }}
              onClick={() => { selectMobile('Lot 1') }} />
              <div
              style={{
                width: '16%',
                height: '14%',
                position: 'absolute',
                left: '30%',
                top: '61%',
                cursor: 'pointer',
                transform: 'translate(-50%,-50%)'
              }}
              onClick={() => { selectMobile('Lot A') }} />
              <div
              style={{
                width: '28%',
                height: '12%',
                position: 'absolute',
                left: '60%',
                top: '64%',
                cursor: 'pointer',
                transform: 'translate(-50%,-50%)'
              }}
              onClick={() => { selectMobile('Lot B') }} />
               <div
              style={{
                width: '16%',
                height: '20%',
                position: 'absolute',
                left: '30%',
                top: '78%',
                cursor: 'pointer',
                transform: 'translate(-50%,-50%)'
              }}
              onClick={() => { selectMobile('Lot C') }} />
              <div
              style={{
                width: '28%',
                height: '24%',
                position: 'absolute',
                left: '60%',
                top: '82%',
                cursor: 'pointer',
                transform: 'translate(-50%,-50%)'
              }}
              onClick={() => { selectMobile('Lot D') }} />
              <div
              style={{
                width: '20%',
                height: '45%',
                position: 'absolute',
                left: '10%',
                top: '70%',
                cursor: 'pointer',
                transform: 'translate(-50%,-50%)'
              }}
              onClick={() => { selectMobile('Lot E') }} />
          </div>
         
        </div>
        </div>
      )}
      <Popup
        passRef={r => popup = r}
        translations={translations}
        locale={locale}
        width={windowWidth}
        closeFn={closePopUp}
        selectFn={selectFn}
      />
    </Fragment>
  );
};


export default ParkingLot;
